import React from "react";
import { TouchableOpacity, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import appStyles from "../../../../appStyles";

export default function InsightsWhiteIcon(props) {
  const width = props.width || 20;
  const height = props.height || 20;
  const color = props.fillColor || "#FFF";

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M17.5006 6.66992C16.2923 6.66992 15.6173 7.86992 15.8923 8.76159L12.934 11.7283C12.684 11.6533 12.3173 11.6533 12.0673 11.7283L9.94232 9.60326C10.2257 8.71159 9.55065 7.50326 8.33398 7.50326C7.12565 7.50326 6.44232 8.70326 6.72565 9.60326L2.92565 13.3949C2.03398 13.1199 0.833984 13.7949 0.833984 15.0033C0.833984 15.9199 1.58398 16.6699 2.50065 16.6699C3.70898 16.6699 4.38398 15.4699 4.10898 14.5783L7.90065 10.7783C8.15065 10.8533 8.51732 10.8533 8.76732 10.7783L10.8923 12.9033C10.609 13.7949 11.284 15.0033 12.5007 15.0033C13.709 15.0033 14.3923 13.8033 14.109 12.9033L17.0756 9.94492C17.9673 10.2199 19.1673 9.54492 19.1673 8.33659C19.1673 7.41992 18.4173 6.66992 17.5006 6.66992Z"
          fill={color}
        />
        <Path
          d="M12.501 7.50195L13.2843 5.77695L15.001 5.00195L13.2843 4.22695L12.501 2.50195L11.7343 4.22695L10.001 5.00195L11.7343 5.77695L12.501 7.50195Z"
          fill={color}
        />
        <Path
          d="M2.91732 9.16862L3.33398 7.50195L5.00065 7.08529L3.33398 6.66862L2.91732 5.00195L2.50065 6.66862L0.833984 7.08529L2.50065 7.50195L2.91732 9.16862Z"
          fill={color}
        />
      </Svg>
    </TAG>
  );
}
